import { Alert, Box, Typography } from "@mui/material";

/** Where RequireAuthority sends a refusal. */
export function UnauthorizedPage() {
  return (
    <Box>
      <Typography variant="h5" component="h2" gutterBottom>
        Not authorized
      </Typography>
      <Alert severity="warning" role="alert">
        You don’t have permission to access this page.
      </Alert>
    </Box>
  );
}
